/**
 * File: gallery.js
 *
 * Adds a lightbox gallery
 */
( function () {
	const lightbox = GLightbox( {} );
} )();
